
import Dashboard from './dashboard.vue'



export default {
  Dashboard,
}


// WEBPACK FOOTER //
// ./src/views/dashboard/index.js